import { render, staticRenderFns } from "./MeetingAgenda.vue?vue&type=template&id=36b48562&"
import script from "./MeetingAgenda.vue?vue&type=script&lang=js&"
export * from "./MeetingAgenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports